import { useNavigate, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { LoginForm } from '../../components/auth'
import { useAuthStore } from '../../store'

/**
 * Pagina di login
 */
export default function Login() {
  const navigate = useNavigate()
  const location = useLocation()
  const { utente } = useAuthStore()

  // Redirect se già loggato
  useEffect(() => {
    if (utente) {
      const from = (location.state as any)?.from?.pathname || '/'
      navigate(from, { replace: true })
    }
  }, [utente, navigate, location])

  const handleSuccess = () => {
    const from = (location.state as any)?.from?.pathname || '/'
    navigate(from, { replace: true })
  }

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-md mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="font-display text-4xl text-white mb-2">Accedi</h1>
          <p className="text-gray-400">
            Entra nel tuo account per salvare i preferiti e segnalare nuovi locali
          </p>
        </div>

        {/* Card form */}
        <div className="bg-night-light border border-gray-800 rounded-xl p-8">
          <LoginForm onSuccess={handleSuccess} />
        </div>
      </div>
    </div>
  )
}
